<!-- app-header -->
<header class="app-header">
  <!-- Start::main-header-container -->
  <div class="main-header-container container-fluid">
    <!-- Start::header-content-left -->
    <div class="header-content-left">
      <!-- Start::header-element -->
      <div class="header-element mx-lg-0 mx-2">
        <a
          aria-label="Hide Sidebar"
          (click)="toggleSidebar()"
          class="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
          data-bs-toggle="sidebar"
          ><span></span
        ></a>
      </div>
      <!-- End::header-element -->
    </div>
    <!-- End::header-content-left -->

    <!-- Start::header-content-right -->
    <ul class="header-content-right" style="align-items: center;">
      <span
        [class.bg-secondary-transparent]="userInfo.role == 'ADMIN'"
        class="badge bg-dark fs-13"
        style="justify-items: center; align-content: center;"
        >
            @if(userInfo.role === 'ADMIN') {
                Amministratore
            }
        </span>
      <!-- Start::header-element profile -->
      <li ngbDropdown class="header-element">
        <!-- Start::header-link|dropdown-toggle -->

        <a
          ngbDropdownToggle
          href="javascript:void(0);"
          class="header-link dropdown-toggle"
          id="mainHeaderProfile"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-expanded="false"
        >
          <div class="d-flex align-items-center">
            <div class="me-sm-2 me-0">
              <i class="bi bi-person-circle avatar-icon"></i>
            </div>
            <div class="d-xl-block d-none lh-1">
              <span class="fw-medium lh-1">
                @if(getLoggedUserName() == null) {
                  <div class="spinner-border spinner-border-sm me-4" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                }
                @else {
                  {{ getLoggedUserName() }}
                }
              </span>
              <!--! NAME OF USER -->
            </div>
          </div>
        </a>
        <!-- End::header-link|dropdown-toggle -->
        <ul
          ngbDropdownMenu
          class="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end full-width"
          aria-labelledby="mainHeaderProfile"
        >
          <!-- <li>
            <a
              ngbDropdownItem
              class="dropdown-item d-flex align-items-center"
              routerLink="/pages/profile"
              ><i class="bi bi-person fs-18 me-2 op-7"></i>Profile</a
            >
          </li> -->
          <li>
            <a
              ngbDropdownItem
              class="dropdown-item d-flex align-items-center"
              (click)="logOut()"
              ><i class="bi bi-box-arrow-right fs-18 me-2 op-7"></i>Log Out</a
            >
          </li>
        </ul>
      </li>
      <!-- End::header-element -->
    </ul>
    <!-- End::header-content-right -->
    <!-- End::header-content-right -->
  </div>
  <!-- End::main-header-container -->
</header>
<!-- /app-header -->
<ng-template #content let-modal>
  <div class="modal-body">
    <div class="input-group">
      <input
        type="text"
        class="form-control border-end-0"
        placeholder="Search Anything ..."
        aria-label="Search Anything ..."
        aria-describedby="button-addon2"
      />
      <button class="btn btn-primary" type="button" id="button-addon2">
        <i class="bi bi-search"></i>
      </button>
    </div>
  </div>
</ng-template>
